import styled from 'styled-components';
import Split from 'react-split';

const TOOLBAR_OFFSET = '5px';
const TABBAR_HEIGHT = '55px';

export const Overlay = styled.div`
  position: fixed;
  z-index: 10;
  background-color: ${({ theme }) => theme.vars.newColor.white};
  height: 100%;
  width: 100%;
`;

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - ${TOOLBAR_OFFSET});
`;

export const TabBarAndWindowLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - ${TABBAR_HEIGHT});
  width: 100%;
`;

export const SplitPanelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  flex-grow: 1;
  flex-shrink: 1;
  overflow: hidden;
`;

export const SplitPanelContainer = styled(Split)`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  .gutter {
    display: flex;
    flex-shrink: 0;
    flex-grow: 0;
    :hover {
      cursor: ew-resize;
    }
  }
`;

export const LeftPaneContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-shrink: 1;
  min-width: 0;
`;

export const RcsTabsWrapper = styled.div`
  height: 100%;
  min-height: 0;
  [data-testid='TabBarElement'] {
    margin-left: ${({ theme }) => theme.designToken.spacing4};
  }
`;

export const RightPaneWrapper = styled.div`
  display: flex;
  border-left: ${({ theme }) => `1px solid ${theme.vars.newColor.lightGS1}`};
  height: 100%;
  width: 100%;
  flex-shrink: 1;
  flex-grow: 1;
  flex-direction: column;
`;

export const RightPaneContent = styled.div`
  flex-grow: 1;
  height: 100%;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.vars.newColor.white};
`;

export const RightPanePreviewArea = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

export const AlertContainer = styled.div`
  padding: 2em;
`;

export const PlaceholderPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 24px;
  color: ${({ theme }) => theme.vars.newColor.darkGS2};
  font-size: 1.4rem;
  text-align: center;
`;

export const MobilePreviewContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 24px;
  overflow: auto;
`;

export const PreviewRequired = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-width: 0;
`;

export const PreviewInfoPanel = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-width: 0;
  word-break: break-word;
`;

export const NameBarElement = styled.div`
  display: flex;
  padding-left: 20px;
  width: 100%;
  height: 40px;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
  position: relative;
  z-index: 10;
`;

export const NameBarElementItem = styled.div<{ minWidth?: string }>`
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  gap: 5px;
  ${({ minWidth }) => minWidth && `min-width: ${minWidth};`}
`;

export const ConfigScrollContainer = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: ${({ theme }) => theme.designToken.spacing4};
`;

export const SnapshotEditorContainer = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  position: relative;
`;

export const SnapshotViewContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;

export const SnapshotHeaderButtons = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.designToken.spacing2};
`;

export const ConfigHeaderWrapper = styled.div`
  padding-bottom: ${({ theme }) => theme.designToken.spacing3};
  margin-bottom: ${({ theme }) => theme.designToken.spacing3};
  border-bottom: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
`;

export const ConfigSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.designToken.spacing4};
`;

export const ConfigSectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.designToken.spacing2};
  margin-bottom: ${({ theme }) => theme.designToken.spacing3};
  padding-bottom: ${({ theme }) => theme.designToken.spacing2};
  border-bottom: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};

  .section-icon {
    color: ${({ theme }) => theme.designToken.primary700};
  }
`;

export const FallbackSectionHeaderRow = styled(ConfigSectionHeader)`
  justify-content: space-between;
  flex-wrap: wrap;
  row-gap: ${({ theme }) => theme.designToken.spacing2};
`;

export const FallbackSectionHeaderLeading = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.designToken.spacing2};
`;

export const SectionIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.designToken.primary50};

  .section-icon {
    color: ${({ theme }) => theme.designToken.primary700};
  }
`;

export const SectionRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.designToken.spacing1};
`;

export const TooltipTriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  cursor: pointer;
  color: inherit;
`;

export const ConfigSectionTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.vars.newColor.darkGS1};
`;

export const ConfigContentFields = styled.div`
  width: 100%;
`;

export const ActionCard = styled.div`
  background-color: ${({ theme }) => theme.vars.newColor.lightGS2};
  border-radius: 8px;
  padding: ${({ theme }) => theme.designToken.spacing4};
  margin-bottom: ${({ theme }) => theme.designToken.spacing3};
  position: relative;
`;

export const ActionCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.designToken.spacing3};
`;

export const ActionCardTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.vars.newColor.darkGS1};
`;

export const AddCtaButtonWrapper = styled.div`
  margin-top: ${({ theme }) => theme.designToken.spacing4};
`;

export const ActionCardSelectWrapper = styled.div`
  width: 100%;

  & > div:first-of-type {
    margin-bottom: ${({ theme }) => theme.designToken.spacing1};
  }

  & > div:last-of-type {
    width: 100%;
    display: block;

    & > div {
      width: 100%;
      display: block;
    }

    button {
      width: 100%;
      min-height: 48px;
      padding: 0 15px;
      text-align: left;
      font-weight: 500;
      color: ${({ theme }) => theme.vars.newColor.darkGS1};
      background-color: ${({ theme }) => theme.vars.newColor.white};
      border: 1px solid ${({ theme }) => theme.designToken.neutral300};
      box-sizing: border-box;
      line-height: 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &:hover {
        color: ${({ theme }) => theme.vars.newColor.darkGS1};
      }
    }
  }
`;

export const ActionCardFieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.designToken.spacing3};
`;

export const ChooseTemplateButtonWrapper = styled.div`
  max-width: 220px;
`;

export const FallbackSectionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: ${({ theme }) => theme.designToken.spacing3};
`;

export const FallbackTemplateName = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.vars.newColor.darkGS1};
  flex: 1;
  min-width: 0;
`;
